module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-23-0705b189540cef5ea6cf4e0ee09c3eef.svg";